<template>

</template>

<script>
    import Cookies from 'js-cookie'
    export default {
        name: "home",
        data(){
            return {
                userId:'',
                siteId:''
            }
        },
        created(){
            this.siteId = this.$route.query.siteId;
            if (!this.siteId) {
                this.$router.push('/admin/multiple')
            }else {
                Cookies.set('siteId',this.siteId);
            }
            this.init();
            /*this.userId = Cookies.get('user_id')
            this.$http.get('/v1/sites/exist',{params:{userId:this.userId}}).then((res)=>{
                if (res.data.siteCount == 0) {
                    this.$router.push('/admin/multiple')
                }else {
                    this.init();
                }
            })*/
        },

        methods:{
            init(){
                var screenWidth = window.screen.width;
                if (screenWidth > 800){
                    this.$router.push('/admin/home')
                }else{
                    this.$router.push('/mobile')
                }
            }
        }
    }
</script>

<style scoped>

</style>
